{
  "contacts": {
    "all_contacts": "All Contacts",
    "all_employees": "All Employees",
    "company_type": "Company type",
    "consent_status": "Consent status",
    "results": "Results",
    "add_new_contact": {
      "continue": "Continue",
      "add_new_contact": "Add new contact",
      "success": "You've successfully created a new contact",
      "first_step_header": "Add new Contact to the person",
      "first_step_header_description": "Add a New Company Email or Personal Email to the Person and we'll create a new Contact based on that.",
      "email_already_exist_in_this_person": "This email already exist in this Person's records. Check archived contacts if you don't see it.",
      "email_already_exist_in_another_person": "This email already exist in another Person's records. Check archived contacts if you don't see it.",
      "i_dont_have_email_for_this_contact": "I don't have email for this contact",
      "this_person_already_has_a_contact_with_this_company": "This Person already has a contact with this company.",
      "company_name": "Company Name",
      "switch_back_to_email": "Switch back to Email",
      "email": "Email",
      "job_title": "Job Title",
      "add_company_contact": "Add Company Contact",
      "we_detected_this_email_is_a_company_email": "We've detected this email is a company email. Please review details",
      "there_was_an_error_validating_the_email": "There was an error validating the email",
      "please_use_a_valid_email_address": "Please use a valid email address",
      "are_you_sure_you_want_to_consolidate_these_persons_into_single_person_profile": "Are you sure you want to consolidate these Persons into single Person profile?",
      "personal_details": "Personal details",
      "contacts": "Contacts",
      "review_potential_duplicates_of_the_person": "Review potential duplicates of the Person",
      "we_detected_potential_person_duplicate_for_the_email_you_want_to_add": "We've detected Potential Person Duplicate for the email you want to add. You can flag them for admin review.",
      "potential_duplicates_have_been_flagged_for_review": "Potential Duplicates have been flagged for review",
      "thanks_for_helping_keep_our_data_clean": "Thanks for helping keep our data clean! Admin users will review and take action to manage these records.",
      "start_consolidating": "Start consolidating",
      "flag_as_duplicates": "Flag as duplicates",
      "move_email": "Move email?",
      "we_might_have_misplaced_the_email": "These persons aren't duplicates, so we might have misplaced the email. Should we move it to the current profile?",
      "visit_profile": "Visit Profile",
      "these_are_not_duplicates": "These are not duplicates"
    }
  },
  "companies": {
    "all_companies": "All Companies",
    "incomplete": {
      "table": {
        "headers": {
          "company": "Company",
          "last_interaction_total": "Last Interaction (Total)",
          "created_at": "Created At",
          "type": "Type",
          "missing_info": "Missing Info",
          "actions": "Actions"
        }
      },
      "actions": {
        "update_company": "Update Company",
        "ignore_company": "ignore company",
        "edit_company": "edit company",
        "export_companies": "Export Companies"
      },
      "bulk_actions": {
        "ignore": "Ignore",
        "archive": "Archive"
      },
      "order_by": "Order by",
      "update": {
        "modal_title": "Update Company Data",
        "loading": "Loading company",
        "form": {
          "type": "Type",
          "industries": "Industries",
          "street_address": "Street Address",
          "city": "City",
          "state": "State",
          "postcode": "Postcode",
          "set_primary_location": "Set as Primary Location"
        }
      }
    },
    "duplicate": {
      "table": {
        "headers": {
          "company": "Company",
          "type": "Type",
          "contacts": "Contacts",
          "last_interaction": "Last Interaction",
          "action": "Action"
        }
      },
      "actions": {
        "merge": "Merge",
        "keep_both": "Keep Both",
        "continue": "Continue"
      },
      "merge": {
        "modal_title": "Merge Company",
        "manual_modal_title": "Manual Merge",
        "description": "We will combine both companies' contacts and interactions. The unselected company's notes, tasks, and documents will be permanently removed.",
        "manual_description": "We will combine both companies' contacts and interactions. Any notes, tasks, and documents other than those of the main company will be permanently deleted.",
        "warning": "Merged companies can't be undone. Please make sure you select the right company.",
        "select_main_company": "Please select the company as the main contact:",
        "main_company": "Main Company",
        "company_to_merge": "Company to be merged",
        "type_to_confirm": "Type \"{{label}}\" to confirm",
        "placeholder_merge": "Type to search main company",
        "placeholder_to_merge": "Type to search company to be merged",
        "merged_result_preview": "Merged Result Preview",
        "placeholder_confirm": "Type \"Merge\" to confirm",
        "continue": "Continue"
      },
      "keep_both": {
        "button": "Keep Both!",
        "confirm_title": "Do you want to add these companies to the same hierarchy?",
        "confirm_content": "By adding them as hierarchy you connect them as a group.",
        "yes": "Yes",
        "no_separate": "No, keep it separate"
      },
      "order_by": "Order by"
    }
  },
  "key_activity": {
    "slide": {
      "aria_label": "key activity slide",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "note": "Note",
      "comments": "Comments"
    },
    "performance": {
      "current": "Current",
      "best": "Best",
      "consecutive": "Consecutive",
      "longest": "Longest",
      "weeks": "Weeks",
      "current_tooltip": "You have logged {{count}} key activities this month",
      "best_tooltip": "Your personal best: {{count}} key activities in a month",
      "consecutive_tooltip": "You've logged weekly key activities for the past {{count}} weeks",
      "longest_tooltip": "Your longest streak: {{count}} weeks"
    },
    "firm_wide": {
      "title": "Firm Wide",
      "this_month": "This Month",
      "tooltip": "Total key activities across the firm this month"
    },
    "grid": {
      "loading_aria_label": "loading key activities",
      "load_limit_message": "There are more key activities than shown.",
      "show_less": "show less",
      "show_more": "+{{count}} more"
    },
    "filters": {
      "select_employee": "Select Employee",
      "select_month_year": "select month and year",
      "select_activity_category": "select activity category",
      "all_employees": "All",
      "basic": "Basic",
      "large": "Large"
    },
    "chart": {
      "business_development": "Business Development Activity",
      "lead_activity": "Lead Activity",
      "marketing_activity": "Marketing Activity"
    },
    "categories": {
      "business_development": "Business Development",
      "lead": "Lead",
      "marketing": "Marketing"
    },
    "forms": {
      "labels": {
        "activity": "Activity",
        "description": "Description",
        "type": "Type",
        "notes": "Notes"
      },
      "placeholders": {
        "activity": "Activity",
        "notes": "Notes",
        "activity_title": "Activity Title"
      },
      "validation": {
        "choose_activity": "Please choose an activity",
        "choose_activity_type": "Please choose activity type"
      }
    },
    "modals": {
      "activity_details": "Activity Details",
      "delete_activity": "Delete Activity",
      "edit_activity": "Edit Activity"
    },
    "interactions": {
      "had_meeting_with": " had a meeting with ",
      "sent_email_to": " sent an email to ",
      "with": " with ",
      "private_between_participants": "Private {{type}} between {{count}} participants",
      "from": "From: ",
      "to": "To: "
    },
    "notes": {
      "view_notes": "View notes",
      "hide_notes": "Hide notes"
    },
    "navigation": {
      "show_less": "show less",
      "show_all": "show all",
      "others": "others"
    },
    "actions": {
      "update_aria_label": "update key activity",
      "update_title": "update key activity",
      "remove_aria_label": "remove key activity",
      "remove_title": "remove key activity",
      "log_new_activity": "Log new activity",
      "mark_as_bd_activity": "Mark as BD Activity",
      "remove_activity": "Remove activity",
      "add_to_list": "Add to List",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save"
    },
    "category_titles": {
      "business_development": "business development activity",
      "lead": "lead activity",
      "marketing": "marketing activity",
      "unknown": "unknown activity"
    },
    "category_labels": {
      "business_development": "business development activity",
      "lead": "lead activity",
      "marketing": "marketing activity",
      "unknown": "unknown activity"
    },
    "email_directions": {
      "employee_sent": "Email sent",
      "employee_received": "Email received"
    },
    "activity_title": {
      "meeting": "Meeting",
      "email": "Email"
    },
    "removal": {
      "confirmation_title": "Are you sure?",
      "confirmation_content": "Deleting the activity will permanently delete the activity and remove from the contact activity feed, calendar and any lists the activity has been added to."
    }
  },
  "mobile_contact_request": {
    "objective_progress": {
      "thanks_for_update": "Thanks for the update :)"
    },
    "contact_request_page": {
      "thank_you_message": "Thank you for adding your contacts. You can close this window now.",
      "im_done": "I'm Done"
    },
    "header": {
      "instruction_text": "Please select and add your contacts you want to add to list \"{{listName}}\". Once you have added your contacts, click on \"I'm done\"."
    },
    "my_contacts": {
      "my_contacts": "My Contacts",
      "company_type": "Company type",
      "consent_status": "Consent status",
      "no_contacts_message": "There's no contact to show here"
    },
    "bulk_add": {
      "contact_list": "Contact List",
      "bulk_add_description": "Bulk add contacts to list",
      "adding_in_progress_message": "The contact is being added. Please refresh the page to see the updated list.",
      "adding_in_progress_title": "Adding Contact in Progress",
      "add_selected": "Add Selected"
    },
    "contacts_table": {
      "selected": "selected",
      "contact": "Contact",
      "company": "Company",
      "location": "Location",
      "last_interaction": "Last Interaction"
    }
  },
  "meetings": {
    "slide": {
      "aria_label": "meeting slide",
      "add_key_activity": "Add key activity",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "companies": "Companies"
    },
    "upcoming": {
      "cancelled": "[Cancelled]",
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "no_meetings_coming_up": "There's no meetings coming up"
    },
    "recent": {
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "create_task": "Create Task",
      "create_note": "Create Note",
      "no_recent_meetings": "You haven't had a meeting for a while"
    },
    "calendar_view": {
      "all": "All",
      "select_all": "Select All",
      "tasks": "Tasks",
      "external_meetings": "External Meetings",
      "key_activities": "Key Activities",
      "task_tooltip": "task"
    },
    "contact_table": {
      "show_less": "Show less",
      "show_more": "Show more"
    },
    "key_activity": {
      "view_activity_details": "view activity details",
      "activity": "Activity",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Edit activity",
      "remove": "Remove"
    }
  },
  "company_list": {
    "show_personal_info": "Show personal info",
    "close_personal_info": "Close personal info"
  },
  "reports": {
    "search_placeholder": "Search Report",
    "loading": "Loading Reports",
    "loading_report": "Loading report",
    "empty_state": "No Reports Available",
    "browser_not_supported": "Your browser does not support iframes."
  },
  "employee": {
    "autocomplete": {
      "no_options_text": "start typing to search for employees",
      "all_option": "All"
    },
    "engagement": {
      "relationship_partner": {
        "title": "Relationship Partner",
        "description": "All companies where this employee is a relationship partner"
      },
      "top_companies": {
        "title": "Top 10 Companies",
        "description": "Top 10 companies by number of interactions"
      },
      "top_contacts": {
        "title": "Top 10 Contacts",
        "description": "Top 10 contacts by number of interactions"
      },
      "table_headers": {
        "company": "Company",
        "opportunities": "Opportunities",
        "partners": "Partners",
        "type": "Type",
        "engagement": "Engagement",
        "industry": "Industry",
        "internal_industry": "Internal Industry",
        "contact": "Contact",
        "interactions_count": "# of Interactions",
        "who_knows": "Who Knows"
      }
    }
  },
  "hierarchy": {
    "slide": {
      "title": "Company Hierarchy",
      "loading_aria_label": "loading company hierarchy",
      "errors": {
        "cannot_move": "Cannot move company:",
        "problem_showing": "Problem showing hierarchy:"
      }
    },
    "view": {
      "dense_view": "Dense view",
      "view_hierarchy": "View Company Hierarchy",
      "companies_count": "Companies:"
    },
    "info": {
      "last_interaction": "Last interaction"
    },
    "actions": {
      "add_child_company": "add new child company under",
      "update_fields": "Update Fields",
      "update_field": "update field",
      "hide_children": "Hide child companies of",
      "show_children": "Show child companies of"
    },
    "removal": {
      "confirmation_title": "Are you sure?",
      "confirmation_content": "Click confirm to remove company from hierarchy. You can always add it back later",
      "remove_label": "Remove {{companyName}} from hierarchy"
    },
    "placement": {
      "title": "Placement",
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Company",
          "location": "Location",
          "actions": "Actions"
        },
        "changed_company": "Changed Company",
        "ignore_contact": "ignore contact",
        "add_to_hierarchy": "add to hierarchy"
      },
      "ignore": {
        "confirmation_title": "Ignore Contact?",
        "confirmation_content": "This action will permanently remove the contact from this list.",
        "label": "ignore"
      }
    },
    "contacts": {
      "move_in_hierarchy": "Move Contacts in Hierarchy",
      "move_contacts": "Move Contacts",
      "select_company": "Select company",
      "company_placeholder": "Company",
      "create_new_company": "Create new company here"
    },
    "company_creation": {
      "modal_title": "Create New Company",
      "create_link": "create new company here",
      "submit_button": "Add",
      "domain_label": "What email domain do contacts from this company use?",
      "domain_placeholder": "Email domain",
      "domain_caption": "Type the email domain contacts of this company will use. Leave blank if it uses the same as the current company.",
      "name_label": "What is the name of the company?",
      "name_placeholder": "Company name",
      "name_caption": "You can change the name of the company at any time.",
      "company_domain_label": "Company Domain",
      "company_name_label": "Company Name"
    },
    "bulk_associate": {
      "add_to_hierarchy": "Add company to hierarchy",
      "modal_title": "Add company to hierarchy",
      "select_companies": "Select companies",
      "companies_placeholder": "Companies",
      "if_not_exist": "If the company does not exist yet,"
    },
    "validation": {
      "company_required": "Company is required",
      "company_name_required": "Company name is required",
      "select_one_company": "please select at least one company",
      "enter_company_name": "please enter a company name"
    }
  },
  "cleaner": {
    "company": {
      "incomplete": {
        "title": "Incomplete",
        "description": "These companies have incomplete data such as location, industry and type."
      },
      "duplicate": {
        "title": "Duplicates",
        "description": "These companies have similar domain names. You can merge the companies or keep them separate.",
        "warning": "Merging companies cannot be undone.",
        "merge_details": "When merging, we will combine both companies' contacts and interactions. Any notes, tasks, and documents other than those of main company will be permanently removed."
      },
      "archived": {
        "title": "Archived",
        "description": "These contacts or companies have been removed from the active database"
      }
    },
    "contact": {
      "incomplete": {
        "title": "Incomplete Contacts",
        "description": "These contacts have incomplete data such as name, role and location."
      },
      "duplicate": {
        "title": "Duplicates",
        "description": "These contacts have the same information such as name. To combine contact, please indicate if these contacts are the same or unique."
      },
      "unengaged": {
        "title": "Unengaged",
        "description": "These contacts have not interacted with your company for some time. Reactivate unengaged contacts with an email or meeting."
      },
      "bounced": {
        "title": "Bounced",
        "description": "Emails of these contacts recently bounced. Please edit the email to the correct address or archive contact to be removed from the lists."
      }
    },
    "tabs": {
      "company": "Company",
      "contact": "Contact"
    }
  }
}
